import React, { useEffect, useRef, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faBolt, faChevronDown, faChevronUp, faXmark, faEuroSign, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';

import Cargotruck from "../../assets/images/cargo-truck.png";
import CargoLogo from '../../assets/images/logocargo.png';
import Completed from '../../assets/images/Completed.svg';
import { withRFSToken } from '../../Services/axios';

const TruckConfirm = ({ trCfId }) => {

    const isMounted = useRef(false);
    const [isdisabled, setIsdisabled] = useState(false);
    const [infoDatas, setInfoDatas] = useState({})
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationData, setConfirmationData] = useState('');

    const [radioState, setRadioState] = useState({
        departure_date: 'Yes',
        arrival_date: 'Yes',
        truck_load: 'Yes',
        no_drivers: 'Yes',
        adr_required: 'Yes',
        temperature_control: 'Yes',
        truck_material: 'Yes',
        min_truck_height: 'Yes',
        rollerbed: 'Yes',
    });

    const [infoData, setInfoData] = useState({
        departure_date_change: '',
        departure_time_change: '',
        arrival_date_change: '',
        arrival_time_change: '',
        truck_load_change: '',
        no_drivers_change: '',
        adr_required_change: '',
        temperature_control_change: '',
        truck_material_change: '',
        min_truck_height_change: '',
        rollerbed_change: '',
    });

    const ltlOptoins = [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
    ];

    const getMissingData = async (encCode) => {
        // const token = localStorage.getItem('TEMAIL');
        // const email = localStorage.getItem('CEmail');
        // const req_id = localStorage.getItem('truck_id');
        try {
            const res = await withRFSToken.post('truck-order-request-data', { truck_request_id: trCfId })
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        let innerData = res.data.response_data;

                        // Transform temperature data
                        if (Array.isArray(innerData.temperature)) {
                            const transformedTemperature = {};
                            innerData.temperature.forEach((tempObj, index) => {
                                const key = Object.keys(tempObj)[0]; // e.g., "temp1", "temp2"
                                const value = tempObj[key]; // e.g., "3-10"

                                if (value && value.includes('-')) {
                                    const [start, end] = value.split('-').map(Number); // Split and convert to numbers
                                    const rangeIndex = index + 1; // Start range indices from 1
                                    transformedTemperature[`temperature_range_${rangeIndex}_start`] = start;
                                    transformedTemperature[`temperature_range_${rangeIndex}_end`] = end;
                                }
                            });

                            // Remove the original temperature array and add transformed data
                            // delete innerData.temperature;
                            innerData = { ...innerData, ...transformedTemperature };
                        }

                        // Set transformed data to state
                        // fetchFixRate(innerData.trucker_id);
                        FixRateSearch(innerData)
                        setInfoDatas(innerData);
                    } else {
                        toast.error(res.data.response_msg);
                        setIsdisabled(true);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchFixRate = async (id) => {
        try {

            const res = await withRFSToken.get(`fixed-rate-list?trucker_id=${id}`)
                .then(function (res) {
                    const innerData = res.data.response_data;

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const FixRateSearch = async (fdata) => {
        const payload = {
            boardPoint : fdata.board_point,
            offPoint : fdata.off_point,
            viaStation : fdata.viaStation || [],
            trucker_id : fdata.trucker_id,
            numberOfDrivers : fdata.number_of_drivers,
            temperatureControl : fdata.temperature_control == 'N' ? 0 : 1,
            adrRequired : fdata.adr_required,
            adrInfo: fdata.adr_info == 1 ? {adrShipments : fdata.adrShipments, adrClasses : fdata.adrClasses} : '',
            rollerbed : fdata.rollerbed,
            weight : fdata.truck_weight,
            truckLoad : fdata.truck_load_type == 'F' ? 'FTL' : 'LTL',
            ltlDetails : {ltlBasis: fdata.ltlBasis, positions: fdata.positions, volume: fdata.volume},

        }
        // console.log("🚀 ~ handleModalOpen ~ payload:", payload)
        try {
            const res = await withRFSToken.post('fix-rate-search', payload);
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                // const handlerRow = innerData?.find(i => i.trucking_company == truckerParent.trucker_name);
                // setTruckerData(handlerRow)
                // setShowModal(true)
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }

    useEffect(() => {
        if (isMounted.current) return;
        getMissingData();
        isMounted.current = true;
    }, []);

    const handleRadioChange = (name, value) => {
        setRadioState((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        // Clear associated info data if "Yes" is selected
        if (value === 'Yes') {
            if (name === 'departure_date') {
                setInfoData((prevData) => ({
                    ...prevData,
                    [`${name}_change`]: '',
                    departure_time_change: '',
                }));
            } else if (name === 'arrival_date') {
                setInfoData((prevData) => ({
                    ...prevData,
                    [`${name}_change`]: '',
                    arrival_date_change: '',
                }));
            } else {
                setInfoData((prevData) => ({
                    ...prevData,
                    [`${name}_change`]: '',
                }));
            }

        }
    };
    const handleInfoChange = (name, value) => {
        if (name === 'truck_material_change') {
            setInfoData((prevData) => ({
                ...prevData,
                [name]: value,
                extra_truck_specification: []
            }));
        } else if (name === 'temperature_control_change') {
            setInfoData((prevData) => ({
                ...prevData,
                [name]: value,
                temperature_range_1_start: '',
                temperature_range_1_end: '',
                temperature_range_2_start: '',
                temperature_range_2_end: '',
            }));
        } else if (name === 'truck_load_change') {
            setInfoData((prevData) => ({
                ...prevData,
                [name]: value,
                service_type_value: ''
            }));
        } else {
            setInfoData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }

    };

    const tempChange = (key, e) => {

        const numericValue = parseFloat(e.target.value);
        setInfoData((prev) => {
            if (!isNaN(numericValue)) {
                if (key.endsWith('_end')) {
                    const startKey = key.replace('_end', '_start');
                    return {
                        ...prev,
                        [key]: Math.max(prev[startKey], Math.min(numericValue, 18)), // Clamp between start value and 18
                    };
                } else {
                    return {
                        ...prev,
                        [key]: Math.max(0, Math.min(numericValue, 18)), // Clamp between 0 and 18
                    };
                }
            } else {
                return {
                    ...prev,
                    [key]: key.endsWith('_end') ? prev[key.replace('_end', '_start')] : 0, // Reset to start value or 0
                };
            }
        });

    }
    const handleIncrease = (key, maxValue) => {

        setInfoData((prev) => {
            let currentValue = parseFloat(prev[key]) || 0;
            if (key.endsWith('_end')) {
                const startKey = key.replace('_end', '_start');
                currentValue = Math.max(prev[startKey], currentValue); // Ensure it respects the start value
            }
            return {
                ...prev,
                [key]: Math.min(currentValue + 1, maxValue), // Increment and ensure it doesn't exceed max value
            };
        });
    }
    const handleDecrease = (key, minValue) => {

        setInfoData((prev) => {
            let currentValue = parseFloat(prev[key]) || 0;
            if (key.endsWith('_end')) {
                const startKey = key.replace('_end', '_start');
                minValue = prev[startKey]; // Set minValue to the corresponding start value
            }
            return {
                ...prev,
                [key]: Math.max(currentValue - 1, minValue), // Decrement and ensure it doesn't go below min value
            };
        });
    }

    const handleExtraTruckSpecChange = (e) => {
        const { value, checked } = e.target;
        setInfoData(prevFormData => {
            let updatedSpecifications = [...(prevFormData.extra_truck_specification || [])];
            if (checked) {
                updatedSpecifications.push(value); // Add selected option
            } else {
                updatedSpecifications = updatedSpecifications.filter(spec => spec !== value); // Remove unselected option
            }
            return {
                ...prevFormData,
                extra_truck_specification: updatedSpecifications,
            };
        });
    }
    const handleShowModal = (conf) => {
        setConfirmationData(conf);
        setShowConfirmation(true);
    }
    const handleConfirm = (con) => {
        if (con === 'Y') {
            handleSubmit(confirmationData)
        } else {

        }
        setShowConfirmation(false);
    }
    const handleSubmit = async (confirm) => {

        // const token = localStorage.getItem('TEMAIL');
        // const status = confirm === 'Y' ? 1 : 0;
        // const transformData = (infoData) => {

        //     const transformedData = { ...infoData };


        //     transformedData.temperature = [];


        //     if (infoData.temperature_control_change === "TC") {
        //         transformedData.temperature.push({ temp1: `${infoData.temperature_range_1_start}-${infoData.temperature_range_1_end}` });
        //     } else if (infoData.temperature_control_change === "MC") {
        //         transformedData.temperature.push({ temp1: `${infoData.temperature_range_1_start}-${infoData.temperature_range_1_end}` });
        //         transformedData.temperature.push({ temp2: `${infoData.temperature_range_2_start}-${infoData.temperature_range_2_end}` });
        //     }


        //     delete transformedData.temperature_range_1_start;
        //     delete transformedData.temperature_range_1_end;
        //     delete transformedData.temperature_range_2_start;
        //     delete transformedData.temperature_range_2_end;

        //     return transformedData;
        // };
        // const transformedData = transformData(infoData);
        // const payload = {
        //     ...radioState,
        //     ...transformedData,

        //     // ...filteredInfoData,
        //     // temperature: temp,
        // };
        // const req_id = localStorage.getItem('truck_id');
        // // console.log('Payload:', payload);
        // // console.log('info:', infoData.currency, infoData.response_amount);
        // // const sss = {email_approval_token: localStorage.getItem('TEMAIL'), email: localStorage.getItem('CEmail')}
        // // console.log('sss:', sss);
        // try {
        //     const res = await withTemailToken.post('requirement-response',
        //         {
        //             truck_request_id: req_id,
        //             requirement_response: payload,
        //             currency_type: !infoData.currency ? '€' : infoData.currency,
        //             response_amount: infoData.response_amount,
        //             offer_status: status,
        //             email_approval_token: localStorage.getItem('TEMAIL'),
        //             email: localStorage.getItem('CEmail')
        //         })
        //         .then(function (res) {
        //             if (res.data.response_code === 200) {
        //                 toast.success(res.data.response_msg)
        //                 // setFinishStep(true);
        //             } else {
        //                 toast.error(res.data.response_msg)
        //             }
        //         });

        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }

    };


    return (
        <div className="truck_requst_from">
            <div className='text-center'>
                <h3 className='mt-3'>Truck Request</h3>
                <p className='mb-4'>
                    Confirm below if a truck is available. <br />
                    For unavailable specifications, select 'No' and specify the alternative option available.
                </p>
            </div>
            <Row>
                <Col sm='6'>
                    <div className='missing_info mb-0'>
                        <h4>Truck Request</h4>
                        <p>Confirm below if a truck is available.</p>

                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.departure_date === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Departure Time - {infoDatas.board_point}</div>
                            <div className='dep_ans'>{infoDatas.departure_date}, {infoDatas.departure_time}</div>
                            <div>
                                <Form.Check
                                    id='dept'
                                    name='departure_date'
                                    inline
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.departure_date === 'Yes'}
                                    onChange={() => handleRadioChange('departure_date', 'Yes')}
                                />
                                <Form.Check
                                    id='dept1'
                                    name='departure_date'
                                    inline
                                    label="No"
                                    type='radio'
                                    checked={radioState.departure_date === 'No'}
                                    onChange={() => handleRadioChange('departure_date', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.departure_date === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <Form.Group as={Row} className='mb-2 w-50'>
                                    {/* <Form.Label>I have truck load LTL : </Form.Label> */}
                                    <Col sm="6">
                                        <Form.Control
                                            name='departure_date_change'
                                            type='date'
                                            value={infoData.departure_date_change}
                                            onChange={(e) => handleInfoChange('departure_date_change', e.target.value)}
                                            placeholder='Date'
                                        />
                                    </Col>
                                    <Col sm="6">
                                        <Form.Control
                                            name='departure_time_change'
                                            type='time'
                                            value={infoData.departure_time_change}
                                            onChange={(e) => handleInfoChange('departure_time_change', e.target.value)}
                                            placeholder='Date'
                                        />
                                    </Col>
                                </Form.Group>
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.arrival_date === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Arrival Time - {infoDatas.off_point}</div>
                            <div className='dep_ans'>{infoDatas.arrival_date}, {infoDatas.arrival_time}</div>
                            <div>
                                <Form.Check
                                    id='arv'
                                    name='arrival_date'
                                    inline
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.arrival_date === 'Yes'}
                                    onChange={() => handleRadioChange('arrival_date', 'Yes')}
                                />
                                <Form.Check
                                    id='arv'
                                    name='arrival_date'
                                    inline
                                    label="No"
                                    type='radio'
                                    checked={radioState.arrival_date === 'No'}
                                    onChange={() => handleRadioChange('arrival_date', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.arrival_date === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <Form.Group as={Row} className='mb-2 w-50'>
                                    {/* <Form.Label>I have truck load LTL : </Form.Label> */}
                                    <Col sm="6">
                                        <Form.Control
                                            name='arrival_date_change'
                                            type='date'
                                            value={infoData.arrival_date_change}
                                            onChange={(e) => handleInfoChange('arrival_date_change', e.target.value)}
                                            placeholder='Date'
                                        />
                                    </Col>
                                    <Col sm="6">
                                        <Form.Control
                                            name='arrival_time_change'
                                            type='time'
                                            value={infoData.arrival_time_change}
                                            onChange={(e) => handleInfoChange('arrival_time_change', e.target.value)}
                                            placeholder='Date'
                                        />
                                    </Col>
                                </Form.Group>
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.truck_load === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Truck Load</div>
                            <div className='dep_ans'>{infoDatas.truck_load_type == 'L' ? 'LTL' : 'FTL'}</div>
                            <div>
                                <Form.Check
                                    inline
                                    name='truck_load'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.truck_load === 'Yes'}
                                    onChange={() => handleRadioChange('truck_load', 'Yes')}
                                />
                                <Form.Check
                                    inline
                                    name='truck_load'
                                    label="No"
                                    type='radio'
                                    checked={radioState.truck_load === 'No'}
                                    onChange={() => handleRadioChange('truck_load', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.truck_load === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>
                                <div className='d-flex sl_status'>

                                    <Form.Check
                                        inline
                                        label="FTL"
                                        name="truck_load_change"
                                        type='radio'
                                        id='ftl'
                                        value="F"
                                        checked={infoData?.truck_load_change === 'F'}
                                        onChange={(e) => handleInfoChange('truck_load_change', 'F')}
                                    />

                                    <Form.Check
                                        inline
                                        label="LTL"
                                        name="truck_load_change"
                                        type='radio'
                                        id='ltl'
                                        value="L"
                                        checked={infoData?.truck_load_change === 'L'}
                                        onChange={(e) => handleInfoChange('truck_load_change', 'L')}
                                    />

                                    <div className='ltl_drop'>

                                        {infoData?.truck_load_change === 'L' &&
                                            <Select
                                                options={ltlOptoins}
                                                onChange={(selected) => {
                                                    const updatedData = { ...infoData, service_type_value: selected.value };
                                                    setInfoData(updatedData);
                                                }}
                                                placeholder="Amount of Positions"
                                                className='rfs_autoslct'
                                                name="service_type_value"
                                                value={ltlOptoins.find(option => option.value === String(infoData.service_type_value))}
                                            />
                                        }
                                    </div>
                                </div>
                                {/* <Form.Select aria-label="Default select example" className='w-25'
                                            value={infoData.truck_load_change}
                                            onChange={(e) => handleInfoChange('truck_load_change', e.target.value)}
                                        >
                                            <option>Position</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </Form.Select> */}
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.no_drivers === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Number of Drivers</div>
                            <div className='dep_ans'>{infoDatas.number_of_drivers}</div>
                            <div>
                                <Form.Check inline
                                    name='no_drivers'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.no_drivers === 'Yes'}
                                    onChange={() => handleRadioChange('no_drivers', 'Yes')}
                                />
                                <Form.Check inline
                                    name='no_drivers'
                                    label="No"
                                    type='radio'
                                    checked={radioState.no_drivers === 'No'}
                                    onChange={() => handleRadioChange('no_drivers', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.no_drivers === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>
                                <div className='sl_status num_drive'>
                                    <Form.Check
                                        inline
                                        label="1"
                                        name="no_drivers_change"
                                        type='radio'
                                        id='1'
                                        checked={infoData.no_drivers_change == 1}
                                        value={infoData.no_drivers_change}
                                        onChange={(e) => handleInfoChange('no_drivers_change', '1')}
                                    />
                                    <Form.Check
                                        inline
                                        label="2"
                                        name="no_drivers_change"
                                        type='radio'
                                        id='2'
                                        checked={infoData.no_drivers_change == 2}
                                        value={infoData.no_drivers_change}
                                        onChange={(e) => handleInfoChange('no_drivers_change', '2')}
                                    />
                                </div>

                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.adr_required === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>ADR Required</div>
                            <div className='dep_ans'>{infoDatas.adr_required == 1 ? 'Yes' : 'No'}</div>
                            <div>
                                <Form.Check
                                    inline
                                    name='adr_required'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.adr_required === 'Yes'}
                                    onChange={() => handleRadioChange('adr_required', 'Yes')}
                                />
                                <Form.Check
                                    inline
                                    name='adr_required'
                                    label="No"
                                    type='radio'
                                    checked={radioState.adr_required === 'No'}
                                    onChange={() => handleRadioChange('adr_required', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.adr_required === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <div className='sl_status'>
                                    <Form.Check
                                        inline
                                        label="Yes"
                                        name="adr_required_change"
                                        type='radio'
                                        id='1'
                                        value={infoData.adr_required_change}
                                        checked={infoData.adr_required_change == '1'}
                                        onChange={(e) => handleInfoChange('adr_required_change', '1')}
                                    />
                                    <Form.Check
                                        inline
                                        label="No"
                                        name="adr_required_change"
                                        type='radio'
                                        id='0'
                                        value={infoData.adr_required_change}
                                        checked={infoData.adr_required_change == '0'}
                                        onChange={(e) => handleInfoChange('adr_required_change', '0')}
                                    />
                                </div>
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.temperature_control === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Temperature Control</div>
                            <div className='dep_ans'>
                                {
                                    infoDatas.temperature?.length === 1 ?
                                        `(${infoDatas?.temperature_range_1_start}°C - ${infoDatas?.temperature_range_1_end}°C )`
                                        : infoDatas.temperature?.length === 2 ?
                                            `(${infoDatas.temperature_range_1_start}°C - ${infoDatas?.temperature_range_1_end}°C ), (${infoDatas?.temperature_range_2_start}°C - ${infoDatas.temperature_range_2_end}°C )`
                                            : ''
                                }</div>
                            <div>
                                <Form.Check
                                    inline
                                    name='temperature_control'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.temperature_control === 'Yes'}
                                    onChange={() => handleRadioChange('temperature_control', 'Yes')}
                                />
                                <Form.Check
                                    inline
                                    name='temperature_control'
                                    label="No"
                                    type='radio'
                                    checked={radioState.temperature_control === 'No'}
                                    onChange={() => handleRadioChange('temperature_control', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.temperature_control === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <Form.Group as={Row}>
                                    {/* <Form.Label>Temperature Control <span>*</span></Form.Label> */}
                                    <div className='sl_status'>
                                        <Form.Check
                                            inline
                                            label="No"
                                            name="temperature_control_change"
                                            type='radio'
                                            id='N'
                                            value={infoData?.temperature_control_change}
                                            checked={infoData.temperature_control_change === 'N'}
                                            onChange={(e) => handleInfoChange('temperature_control_change', 'N')}
                                        />
                                        <Form.Check
                                            inline
                                            label="Temperature"
                                            name="temperature_control_change"
                                            type='radio'
                                            id='TC'
                                            value={infoData?.temperature_control_change}
                                            checked={infoData.temperature_control_change === 'TC'}
                                            onChange={(e) => handleInfoChange('temperature_control_change', 'TC')}
                                        />
                                        <Form.Check
                                            inline
                                            label="Multi-Temperature "
                                            name="temperature_control_change"
                                            type='radio'
                                            id='MC'
                                            value={infoData?.temperature_control_change}
                                            checked={infoData.temperature_control_change === 'MC'}
                                            onChange={(e) => handleInfoChange('temperature_control_change', 'MC')}
                                        />

                                        {infoData.temperature_control_change === 'TC' &&
                                            <div className='multi_temp'>
                                                <h4>Temperature Range</h4>
                                                <div className='d-flex'>
                                                    <InputGroup className="ra_temprang">
                                                        <Form.Control
                                                            type="number"
                                                            value={infoData.temperature_range_1_start}
                                                            min={0}
                                                            max={18}
                                                            onChange={(e) => tempChange('temperature_range_1_start', e)}
                                                        />
                                                        <InputGroup.Text>°C</InputGroup.Text>
                                                        <div className='temprt'>
                                                            <div className="d-flex flex-column">
                                                                <Button variant="link" onClick={() => handleIncrease('temperature_range_1_start', 18)} className="">
                                                                    <FontAwesomeIcon icon={faChevronUp} />
                                                                </Button>
                                                                <Button variant="link" onClick={() => handleDecrease('temperature_range_1_start', 0)} className="">
                                                                    <FontAwesomeIcon icon={faChevronDown} />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </InputGroup>
                                                    <span className='rang_gap'>-</span>
                                                    <InputGroup className="ra_temprang">
                                                        <Form.Control
                                                            type="number"
                                                            value={infoData.temperature_range_1_end}
                                                            min={infoData.temperature_range_1_start}
                                                            onChange={(e) => tempChange('temperature_range_1_end', e)}
                                                        />
                                                        <InputGroup.Text>°C</InputGroup.Text>
                                                        <div className='temprt'>
                                                            <div className="d-flex flex-column">
                                                                <Button variant="link" onClick={() => handleIncrease('temperature_range_1_end', 18)} className="">
                                                                    <FontAwesomeIcon icon={faChevronUp} />
                                                                </Button>
                                                                <Button variant="link" onClick={() => handleDecrease('temperature_range_1_end', infoData.temperature_range_1_start)} className="">
                                                                    <FontAwesomeIcon icon={faChevronDown} />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </InputGroup>
                                                </div>

                                            </div>
                                        }
                                        {infoData.temperature_control_change === 'MC' &&
                                            <div className='multi_temp'>
                                                <ul>
                                                    <li>
                                                        <h4>Temperature Range 1</h4>
                                                        <div className='d-flex'>
                                                            <InputGroup className="ra_temprang">
                                                                <Form.Control
                                                                    type="number"
                                                                    value={infoData.temperature_range_1_start}
                                                                    onChange={(e) => tempChange('temperature_range_1_start', e)}
                                                                />
                                                                <InputGroup.Text>°C</InputGroup.Text>
                                                                <div className='temprt'>
                                                                    <div className="d-flex flex-column">
                                                                        <Button variant="link" onClick={() => handleIncrease('temperature_range_1_start', 18)} className="">
                                                                            <FontAwesomeIcon icon={faChevronUp} />
                                                                        </Button>
                                                                        <Button variant="link" onClick={() => handleDecrease('temperature_range_1_start', 0)} className="">
                                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </InputGroup>
                                                            <span className='rang_gap'>-</span>
                                                            <InputGroup className="ra_temprang">
                                                                <Form.Control
                                                                    type="number"
                                                                    value={infoData.temperature_range_1_end}
                                                                    onChange={(e) => tempChange('temperature_range_1_end', e)}
                                                                />
                                                                <InputGroup.Text>°C</InputGroup.Text>
                                                                <div className='temprt'>
                                                                    <div className="d-flex flex-column">
                                                                        <Button variant="link" onClick={() => handleIncrease('temperature_range_1_end', 18)} className="">
                                                                            <FontAwesomeIcon icon={faChevronUp} />
                                                                        </Button>
                                                                        <Button variant="link" onClick={() => handleDecrease('temperature_range_1_end', infoData.temperature_range_1_start)} className="">
                                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </InputGroup>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <h4>Temperature Range 2</h4>
                                                        <div className='d-flex'>
                                                            <InputGroup className="ra_temprang">
                                                                <Form.Control
                                                                    type="number"
                                                                    value={infoData.temperature_range_2_start}
                                                                    onChange={(e) => tempChange('temperature_range_2_start', e)}
                                                                />
                                                                <InputGroup.Text>°C</InputGroup.Text>
                                                                <div className='temprt'>
                                                                    <div className="d-flex flex-column">
                                                                        <Button variant="link" onClick={() => handleIncrease('temperature_range_2_start', 18)} className="">
                                                                            <FontAwesomeIcon icon={faChevronUp} />
                                                                        </Button>
                                                                        <Button variant="link" onClick={() => handleDecrease('temperature_range_2_start', 0)} className="">
                                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </InputGroup>
                                                            <span className='rang_gap'>-</span>
                                                            <InputGroup className="ra_temprang">
                                                                <Form.Control
                                                                    type="number"
                                                                    value={infoData.temperature_range_2_end}
                                                                    onChange={(e) => tempChange('temperature_range_2_end', e)}
                                                                />
                                                                <InputGroup.Text>°C</InputGroup.Text>
                                                                <div className='temprt'>
                                                                    <div className="d-flex flex-column">
                                                                        <Button variant="link" onClick={() => handleIncrease('temperature_range_2_end', 18)} className="">
                                                                            <FontAwesomeIcon icon={faChevronUp} />
                                                                        </Button>
                                                                        <Button variant="link" onClick={() => handleDecrease('temperature_range_2_end', infoData.temperature_range_2_start)} className="">
                                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </InputGroup>
                                                        </div>
                                                    </li>

                                                </ul>

                                            </div>
                                        }
                                    </div>
                                </Form.Group>
                                {/* <Form.Select aria-label="Default select example" className='w-25'
                                            value={infoData.temperature_control_change}
                                            onChange={(e) => handleInfoChange('temperature_control_change', e.target.value)}
                                        >
                                            <option>Position</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </Form.Select> */}
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.truck_material === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Truck Material</div>
                            <div className='dep_ans'>{infoDatas.truck_material == 'HC' ? 'Hard Cover' : infoDatas.truck_material == 'CS' ? 'Curtain Slider' : 'Flatbed Trailer'}</div>
                            <div>
                                <Form.Check
                                    inline
                                    name='truck_material'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.truck_material === 'Yes'}
                                    onChange={() => handleRadioChange('truck_material', 'Yes')}
                                />
                                <Form.Check
                                    inline
                                    name='truck_material'
                                    label="No"
                                    type='radio'
                                    checked={radioState.truck_material === 'No'}
                                    onChange={() => handleRadioChange('truck_material', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.truck_material === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <div className="mb-2 sl_status">
                                    <Form.Check
                                        inline
                                        label="Hard Cover"
                                        name="truck_material_change"
                                        type='radio'
                                        id='HC'
                                        value={infoData.truck_material_change}
                                        checked={infoData.truck_material_change === 'HC'}
                                        onChange={(e) => handleInfoChange('truck_material_change', 'HC')}
                                    />
                                    <Form.Check
                                        inline
                                        label="Curtain Slider"
                                        name="truck_material_change"
                                        type='radio'
                                        id='CS'
                                        value={infoData.truck_material_change}
                                        checked={infoData.truck_material_change === 'CS'}
                                        onChange={(e) => handleInfoChange('truck_material_change', 'CS')}
                                    />
                                    <Form.Check
                                        inline
                                        label="Flatbed Trailer"
                                        name="truck_material_change"
                                        type='radio'
                                        id='FT'
                                        value={infoData.truck_material_change}
                                        checked={infoData.truck_material_change === 'FT'}
                                        onChange={(e) => handleInfoChange('truck_material_change', 'FT')}
                                    />
                                    {infoData.truck_material_change === 'CS' &&
                                        <div className='multi_temp'>
                                            <h4>Extra Truck Option</h4>
                                            <ul>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Extra Wide Truck"
                                                        name="extra_truck_specification"
                                                        value="Extra Wide Truck"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Extra Wide Truck")}
                                                    />
                                                </li>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Soft Top"
                                                        name="extra_truck_specification"
                                                        value="Soft Top"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Soft Top")}
                                                    />
                                                </li>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Reinforced Curtain"
                                                        name="extra_truck_specification"
                                                        value="Reinforced Curtain"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Reinforced Curtain")}
                                                    />
                                                </li>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Adjustable Roof"
                                                        name="extra_truck_specification"
                                                        value="Adjustable Roof"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Adjustable Roof")}
                                                    />
                                                </li>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Exceptional Transport"
                                                        name="extra_truck_specification"
                                                        value="Exceptional Transport"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Exceptional Transport")}
                                                    />
                                                </li>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Side Loading Capbility"
                                                        name="extra_truck_specification"
                                                        value="Side Loading Capbility"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Side Loading Capbility")}
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                    {infoData.truck_material_change === 'FT' &&
                                        <div className='multi_temp'>
                                            <h4>Extra Truck Option</h4>
                                            <ul>
                                                <li>
                                                    <Form.Check
                                                        inline
                                                        label="Extendable Length"
                                                        name="extra_truck_specification"
                                                        value="Extendable Length"
                                                        onChange={handleExtraTruckSpecChange}
                                                        checked={infoData.extra_truck_specification?.includes("Extendable Length")}
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                                {/* <Form.Select aria-label="Default select example" className='w-25'
                                            value={infoData.truck_material_change}
                                            onChange={(e) => handleInfoChange('truck_material_change', e.target.value)}
                                        >
                                            <option>Position</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </Form.Select> */}
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.min_truck_height === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Min. Truck Height (cm) </div>
                            <div className='dep_ans'>{infoDatas.truck_height} cm</div>
                            <div>
                                <Form.Check
                                    inline
                                    name='min_truck_height'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.min_truck_height === 'Yes'}
                                    onChange={() => handleRadioChange('min_truck_height', 'Yes')}
                                />
                                <Form.Check
                                    inline
                                    name='min_truck_height'
                                    label="No"
                                    type='radio'
                                    checked={radioState.min_truck_height === 'No'}
                                    onChange={() => handleRadioChange('min_truck_height', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.min_truck_height === 'No' && (
                            <div className='ifno'>
                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <Form.Control className='w-25'
                                    name='min_truck_height_change'
                                    alue={infoData.min_truck_height_change}
                                    onChange={(e) => handleInfoChange('min_truck_height_change', e.target.value)}
                                    placeholder='Min. Truck Height'
                                    style={{ height: "32px" }}
                                />
                            </div>
                        )}
                        <div className='d-flex gap-3 align-items-center justify-content-between truck_type'>
                            {radioState.rollerbed === 'Yes' ?
                                <div className='type_green'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                : <div className='type_red'><FontAwesomeIcon icon={faCircleXmark} /></div>
                            }
                            <div className='dep'>Rollerbed </div>
                            <div className='dep_ans'>{infoDatas.rollerbed == 'Y' ? 'Yes' : 'No'}</div>
                            <div>
                                <Form.Check
                                    inline
                                    name='rollerbed'
                                    label="Yes"
                                    type='radio'
                                    checked={radioState.rollerbed === 'Yes'}
                                    onChange={() => handleRadioChange('rollerbed', 'Yes')}
                                />
                                <Form.Check
                                    inline
                                    name='rollerbed'
                                    label="No"
                                    type='radio'
                                    checked={radioState.rollerbed === 'No'}
                                    onChange={() => handleRadioChange('rollerbed', 'No')}
                                />
                            </div>
                        </div>
                        {radioState.rollerbed === 'No' && (
                            <div className='ifno'>

                                <div>
                                    <h4>Proposal</h4>
                                    <p>Please indicate alternative option</p>
                                </div>

                                <div>
                                    <Form.Check
                                        inline
                                        label="Yes"
                                        name="rollerbed_change"
                                        type='radio'
                                        id='yes'
                                        value={infoData.rollerbed_change}
                                        checked={infoData.rollerbed_change === 'Y'}
                                        onChange={(e) => handleInfoChange('rollerbed_change', 'Y')}
                                    />
                                    <Form.Check
                                        inline
                                        label="No"
                                        name="rollerbed_change"
                                        type='radio'
                                        id='no'
                                        value={infoData.rollerbed_change}
                                        checked={infoData.rollerbed_change === 'N'}
                                        onChange={(e) => handleInfoChange('rollerbed_change', 'N')}
                                    />
                                    {/* <Form.Select aria-label="Default select example" className='w-25'
                                            value={infoData.rollerbed_change}
                                            onChange={(e) => handleInfoChange('rollerbed_change', e.target.value)}
                                        >
                                            <option>Position</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </Form.Select> */}
                                </div>
                            </div>
                        )}
                        <div className='truck_price'>
                            <div className='d-flex align-items-center'>
                                <Form.Label >Truck Price : </Form.Label>
                                <Form.Select aria-label="Default select example" name='currency' onChange={(e) => handleInfoChange('currency', e.target.value)}>
                                    <option selected value="€">€ EUR</option>
                                    <option value="$">$ USD</option>
                                </Form.Select>
                                <Form.Control
                                    type="text"
                                    name='response_amount' placeholder=""
                                    onChange={(e) => handleInfoChange('response_amount', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                </Col>
                <Col sm='6'>
                    <div className='missing_info h-100'>
                        <h4>Truck Information</h4>
                        <p>Summary of truck information</p>

                        <div className='d-flex justify-content-between rabord summ_info'>
                            <div className='firstbrd'>
                                <p>Boardpoint</p>
                                <span>{infoDatas.board_point}</span>
                            </div>
                            <div className='middlebrd'>
                                <p>{infoDatas.departure_date}</p>
                                <p><img src={Cargotruck} /></p>
                                <p>{infoDatas.departure_time} - {infoDatas.arrival_time}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>Offpoint</p>
                                <span>{infoDatas.off_point}</span>
                            </div>
                        </div>

                        <div className='truck_addr'>
                            <h4>Boardpoint</h4>
                            <p>{infoDatas.board_point_handler_name} - {infoDatas.board_point}</p>
                            <span>{infoDatas.board_point_address}</span>
                        </div>
                        <div className='truck_addr'>
                            <h4>Offpoint</h4>
                            <p>{infoDatas.off_point_handler_name} - {infoDatas.off_point}</p>
                            <span>{infoDatas.off_point_address}</span>
                        </div>
                    </div>
                </Col>
            </Row>
            <div className='text-center mt-4'>
                {!isdisabled &&
                    <>
                        <Button className='cant_deliver' onClick={() => handleShowModal('N')}> <FontAwesomeIcon icon={faCircleXmark} /> I Can't Deliver </Button>
                        <Button className='can_deliver' onClick={() => handleShowModal('Y')}> <FontAwesomeIcon icon={faCircleCheck} /> I Can Deliver </Button>
                    </>

                }
            </div>
        </div>
    )
}

export default TruckConfirm
